var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "partial-release-request-tab"
  }, [_c('vue-element-loading', {
    attrs: {
      "active": _vm.isLoading,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(!_vm.isBulkUploadMode) ? _c('p', [_c('strong', [_vm._v("Logged-in Hub:")]), _vm._v(" " + _vm._s(_vm.userHubName) + " (" + _vm._s(_vm.userHubId) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.isBulkUploadMode) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "requestedShipmentCount"
    }
  }, [_vm._v("Requested Shipment Count")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestedShipmentCount),
      expression: "requestedShipmentCount"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "requestedShipmentCount",
      "type": "number",
      "min": "1",
      "step": "1",
      "disabled": _vm.isLoading || _vm.isSubmitting || !_vm.userHubName,
      "placeholder": "Enter shipment count"
    },
    domProps: {
      "value": (_vm.requestedShipmentCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requestedShipmentCount = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isBulkUploadMode) ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onBulkUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row bulk-hold-scope-row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "d-block"
  }, [_vm._v("Hold scope "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "bulk-scope-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkHoldScope),
      expression: "bulkHoldScope"
    }],
    attrs: {
      "type": "radio",
      "name": "bulkHoldScope",
      "value": "cwb"
    },
    domProps: {
      "checked": _vm._q(_vm.bulkHoldScope, "cwb")
    },
    on: {
      "change": [function($event) {
        _vm.bulkHoldScope = "cwb"
      }, _vm.onHoldScopeChange]
    }
  }), _vm._v("\n                CWB hold\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "bulk-scope-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bulkHoldScope),
      expression: "bulkHoldScope"
    }],
    attrs: {
      "type": "radio",
      "name": "bulkHoldScope",
      "value": "holdAll"
    },
    domProps: {
      "checked": _vm._q(_vm.bulkHoldScope, "holdAll")
    },
    on: {
      "change": [function($event) {
        _vm.bulkHoldScope = "holdAll"
      }, _vm.onHoldScopeChange]
    }
  }), _vm._v("\n                Hold all\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Upload CSV "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" *")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "partialReleaseFile",
      "id": "partial-release-upload",
      "accept": ".csv"
    },
    on: {
      "change": _vm.onFileSelected
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv files allowed to upload.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage && !_vm.uploadedFile),
      expression: "errorMessage && !uploadedFile"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8",
      "text-decoration": "underline"
    },
    attrs: {
      "href": "javascript:void(0)",
      "title": "Download Partial Release template CSV"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadPartialReleaseTemplate.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    class: {
      'fa-spin': _vm.isLoadingOnHold
    }
  }), _vm._v(" Partial Release Template\n                ")])]), _vm._v(" "), _c('p', {
    staticClass: "text-muted template-scope-hint"
  }, [_vm._v("\n                Template rows match the selected hold scope (" + _vm._s(_vm.holdScopeLabel) + "). Use separate uploads for CWB hold vs Hold all.\n              ")]), _vm._v(" "), (_vm.onHoldLoadError) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.onHoldLoadError))]) : _vm._e(), _vm._v(" "), (_vm.templateInfoMessage) ? _c('div', {
    staticClass: "alert alert-info",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v(_vm._s(_vm.templateInfoMessage))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.bulkFailed && _vm.bulkFailed.length > 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download Failed Rows"
    },
    on: {
      "click": _vm.exportBulkFailed
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download CSV\n                    "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#92969D"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    style: (_vm.isSubmitting ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitting || !_vm.uploadedFile
    }
  }, [(_vm.isSubmitting) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              " + _vm._s(_vm.isSubmitting ? 'Uploading...' : 'Upload') + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.clearBulkUploadForm
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear\n            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [(_vm.bulkResultMessage) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.bulkResultMessage))]) : _vm._e(), _vm._v(" "), (_vm.bulkResults && _vm.bulkResults.length) ? _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("CSV Row")]), _vm._v(" "), _c('th', [_vm._v("Parent Hub")]), _vm._v(" "), _c('th', [_vm._v("Parent ID")]), _vm._v(" "), _c('th', [_vm._v("Hubname")]), _vm._v(" "), _c('th', [_vm._v("HubId")]), _vm._v(" "), _c('th', [_vm._v("Requested")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("Released Bags")]), _vm._v(" "), _c('th', [_vm._v("Released Shipments")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.bulkResults), function(r, idx) {
    return _c('tr', {
      key: idx
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.CSVRow || r.csvRow || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("uppercase")((r.Parenthubname || r.parenthubname || '-'))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.Parenthubid || r.parenthubid || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("uppercase")((r.Hubname || r.hubname || '-'))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.HubId || r.hubId || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.Release_Count || r.ReleaseCount || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.Status || r.status || '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.Message || r.message || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.ReleasedBagCount || r.releasedBagCount || (r.ReleasedBags && r.ReleasedBags.length) || 0))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.ReleasedShipmentCount || r.releasedShipmentCount || 0))])])
  }), 0)])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n        "), (!_vm.isBulkUploadMode) ? _c('button', {
    staticClass: "btn btn-sm btn-outline-danger ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || _vm.isSubmitting
    },
    on: {
      "click": _vm.resolveHubName
    }
  }, [_vm._v("\n          Retry\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        " + _vm._s(_vm.successMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.isBulkUploadMode) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.isLoading || _vm.isSubmitting || !_vm.userHubName || !_vm.requestedShipmentCount
    },
    on: {
      "click": _vm.confirmSubmit
    }
  }, [_vm._v("\n        Submit Partial Release Request\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "sm",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.showConfirmModal),
      callback: function($$v) {
        _vm.showConfirmModal = $$v
      },
      expression: "showConfirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onConfirmCancel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.confirmMessage))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.onConfirmProceed
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.onConfirmCancel
    }
  }, [_vm._v("Cancel")])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a06bb904","hasScoped":true}!./src/views/components/CwbHoldRequest/PartialReleaseRequestTab/PartialReleaseRequestTab.html
// module id = 1105
// module chunks = 2